var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"risk-chart"},[(_vm.isLoading)?_c('div',{staticClass:"loader"},[_c('Spinner')],1):_c('canvas',{ref:"chartCanvas"})])
}
var staticRenderFns = []

export { render, staticRenderFns }